module.exports = __webpack_public_path__ + "img/Total Warehouse.41da434f.svg";